module.exports = __webpack_public_path__ + "static/media/SentinelX_logo_dark.88d90fbd.png";